import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle, XCircle } from "@phosphor-icons/react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentEsito() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const annullato = params.get("annullato");
  const [st, setSt] = useState(null);
  const [timeoutHit, setTimeoutHit] = useState(false);

  useEffect(() => {
    if (!sessionId) return undefined;
    let n = 0;
    const t = setInterval(async () => {
      n += 1;
      try {
        const r = await axios.get(`${API}/payments/status/${sessionId}`);
        setSt(r.data);
        if (r.data.payment_status === "paid") clearInterval(t);
      } catch { /* transizione */ }
      if (n > 15) { setTimeoutHit(true); clearInterval(t); }
    }, 2000);
    return () => clearInterval(t);
  }, [sessionId]);

  const paid = st?.payment_status === "paid";

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl border border-zinc-200 p-8 max-w-sm w-full text-center space-y-3" data-testid="payment-esito">
        {annullato ? (
          <>
            <XCircle size={44} weight="fill" className="text-zinc-300 mx-auto" />
            <h1 className="font-bold text-zinc-900" data-testid="payment-esito-title">Pagamento annullato</h1>
            <p className="text-sm text-zinc-500">Nessun addebito effettuato. Puoi riprovare dal link ricevuto.</p>
          </>
        ) : paid ? (
          <>
            <CheckCircle size={44} weight="fill" className="text-emerald-500 mx-auto" />
            <h1 className="font-bold text-zinc-900" data-testid="payment-esito-title">Abbonamento attivo</h1>
            <p className="text-sm text-zinc-500">Pagamento completato. Il tuo account Dishenda è attivo: puoi accedere al gestionale.</p>
          </>
        ) : (
          <>
            <div className="w-9 h-9 border-2 border-zinc-200 border-t-sky-500 rounded-full animate-spin mx-auto" />
            <h1 className="font-bold text-zinc-900" data-testid="payment-esito-title">
              {timeoutHit ? "Verifica in corso" : "Conferma pagamento…"}
            </h1>
            <p className="text-sm text-zinc-500">
              {timeoutHit
                ? "Il pagamento è in fase di conferma da Stripe. Riceverai conferma via email a breve."
                : "Stiamo verificando l'esito del pagamento con Stripe."}
            </p>
          </>
        )}
        <Link to="/login" className="inline-block text-xs font-bold text-sky-700 hover:underline" data-testid="payment-esito-login">
          Vai al login
        </Link>
      </div>
    </div>
  );
}
